export default __webpack_public_path__ + "static/media/Group 17.a44b8298.png";